import Vue from 'vue'
Vue.filter('currency', function (val) {
    if (val) {
        val = val.toString().replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
        let val1 = parseFloat(val).toFixed(2);  //保留两位小数
        let val2 = val1.toString();
        let arr = val2.split('.');
        let arr1 = arr[0].split('');
        let str3 = "";
        let arr2 = [];
        for (let i = arr1.length - 1, j = 0; i >= 0; i-- , j++) {
            str3 = '' + arr1[i] + str3;
            if (j % 3 == 2) {
                arr2.unshift(str3)
                str3 = "";
            } else if (i == 0) {
                arr2.unshift(str3)
            }
        }
        let str4 = arr2.join(',');
        let str5 = str4 + '.' + arr[1];
        return str5
    } else {
        return '00.00';
    }
})
Vue.filter('formatDate', function (time, mark, n) {
    if (time == null || time == '') {
        return '';
    } else {
        var date = new Date(parseInt(time));
        var dYear = date.getFullYear();
        var dMonth = date.getMonth() + 1;
        var dDate = date.getDate();
        var dHours = date.getHours();
        var dMinutes = date.getMinutes();
        var dSeconds = date.getSeconds();
        if (dMonth < 10) {
            dMonth = '0' + dMonth
        }
        if (dDate < 10) {
            dDate = '0' + dDate
        }
        if (dHours < 10) {
            dHours = '0' + dHours
        }
        if (dMinutes < 10) {
            dMinutes = '0' + dMinutes
        }
        if (dSeconds < 10) {
            dSeconds = '0' + dSeconds
        }
        if (mark) {
            if (n == 3) {
                return dHours + mark + dMinutes + mark + dSeconds;
            } else if (n == 0) {
                return dHours + mark + dMinutes;
            } else if (n == 1) {
                return dYear + mark + dMonth + mark + dDate;
            } else if (n == 2) {
                return dYear + mark + dMonth + mark + dDate + ' ' + dHours + ':' + dMinutes;
            } else {
                return dYear + mark + dMonth + mark + dDate + ' ' + dHours + ':' + dMinutes + ':' + dSeconds;
            }
        } else {
            if (n == 1) {
                return dYear + '-' + dMonth + '-' + dDate;
            } else if (n == 2) {
                return dYear + '-' + dMonth + '-' + dDate + ' ' + dHours + ':' + dMinutes;
            } else {
                return dYear + '-' + dMonth + '-' + dDate + ' ' + dHours + ':' + dMinutes + ':' + dSeconds;
            }
        }
    }
})


